import { NgModule }    from "@angular/core";

import { CommonModule }          from "@angular/common";
import { FormsModule }           from "@angular/forms";
import { RouterModule }          from "@angular/router";
import { SearchResultComponent }     from "./search-result.component";
import { SearchResultFileComponent } from "./file/search-result-file.component";
import { PageMenuComponent } from "../../components/page-menu/page-menu";
import {BookComponent} from "../../components/book/book.component";
import {VideoPlayerComponent} from "../../components/video-player/video-player.component";


@NgModule({
	declarations: [
		SearchResultComponent,
		SearchResultFileComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		RouterModule.forChild([
			{
				path: "",
				component: SearchResultComponent
			}
		]),
		PageMenuComponent,
		BookComponent,
		VideoPlayerComponent
	]
})
export class SearchResultModule {
}
